export enum ReservationFeeType {
  TRANSACTION = 'TRANSACTION',
  PEOPLE = 'PEOPLE',
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/enums/reservation-fee-type.enum.ts